














































































































































































































import "./objective-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment-timezone";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import AttachmentEditor from "./attachment-editor.vue";
import DropdownListSelector from "./defined-dropdownlist-selector.vue";
import UnitSelector from "./defined-unit-selector.vue";
import CronExpressionGenerator from "../common/cron-expression-generator.vue";

let parser = require("cron-parser");
let _ = require("lodash");

export default Vue.extend({
  name: "ObjectiveSetup",
  components: {
    AttachmentEditor,
    "defined-dropdownlist-selector": DropdownListSelector,
    "defined-unit-selector": UnitSelector,
    CronExpressionGenerator,
  },
  props: {
    objective: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      timelineOption: {
        disabledDate: (this as any).disabledDateForObjectives,
      },
      gradeRules: {
        label: [
          {
            required: true,
            message: "*",
            trigger: "change",
          },
          {
            type: "string",
            max: 20,
            message: "Max 20 characters.",
            trigger: "change",
          },
        ],
        value: [
          {
            type: "number",
            required: true,
            message: "*",
            trigger: "change",
          },
        ],
      },
      disableAttachmentEdit: false,
      showDatePicker: false,
      datePickerValue: null,
      activePage: "",
      showDetails: false,
      maxPriority: 1,
      currentObjective: {
        name: null,
        description: "",
        trackingQuestion: "",
        priority: NaN,
        measurementUnit: null,
        trackingTarget: null,
        cronExpression: null,
        checkinDates: [],
        checkinTime: null,
        attachments: [],
        targetType: 1,
        inputOptions: [],
        checkinModel: {
          timeOptions: [
            { value: "00:00", label: "12:00 AM", disabled: false },
            { value: "00:30", label: "12:30 AM", disabled: false },
            { value: "01:00", label: "1:00 AM", disabled: false },
            { value: "01:30", label: "1:30 AM", disabled: false },
            { value: "02:00", label: "2:00 AM", disabled: false },
            { value: "02:30", label: "2:30 AM", disabled: false },
            { value: "03:00", label: "3:00 AM", disabled: false },
            { value: "03:30", label: "3:30 AM", disabled: false },
            { value: "04:00", label: "4:00 AM", disabled: false },
            { value: "04:30", label: "4:30 AM", disabled: false },
            { value: "05:00", label: "5:00 AM", disabled: false },
            { value: "05:30", label: "5:30 AM", disabled: false },
            { value: "06:00", label: "6:00 AM", disabled: false },
            { value: "06:30", label: "6:30 AM", disabled: false },
            { value: "07:00", label: "7:00 AM", disabled: false },
            { value: "07:30", label: "7:30 AM", disabled: false },
            { value: "08:00", label: "8:00 AM", disabled: false },
            { value: "08:30", label: "8:30 AM", disabled: false },
            { value: "09:00", label: "9:00 AM", disabled: false },
            { value: "09:30", label: "9:30 AM", disabled: false },
            { value: "10:00", label: "10:00 AM", disabled: false },
            { value: "10:30", label: "10:30 AM", disabled: false },
            { value: "11:00", label: "11:00 AM", disabled: false },
            { value: "11:30", label: "11:30 AM", disabled: false },
            { value: "12:00", label: "12:00 PM", disabled: false },
            { value: "12:30", label: "12:30 PM", disabled: false },
            { value: "13:00", label: "1:00 PM", disabled: false },
            { value: "13:30", label: "1:30 PM", disabled: false },
            { value: "14:00", label: "2:00 PM", disabled: false },
            { value: "14:30", label: "2:30 PM", disabled: false },
            { value: "15:00", label: "3:00 PM", disabled: false },
            { value: "15:30", label: "3:30 PM", disabled: false },
            { value: "16:00", label: "4:00 PM", disabled: false },
            { value: "16:30", label: "4:30 PM", disabled: false },
            { value: "17:00", label: "5:00 PM", disabled: false },
            { value: "17:30", label: "5:30 PM", disabled: false },
            { value: "18:00", label: "6:00 PM", disabled: false },
            { value: "18:30", label: "6:30 PM", disabled: false },
            { value: "19:00", label: "7:00 PM", disabled: false },
            { value: "19:30", label: "7:30 PM", disabled: false },
            { value: "20:00", label: "8:00 PM", disabled: false },
            { value: "20:30", label: "8:30 PM", disabled: false },
            { value: "21:00", label: "9:00 PM", disabled: false },
            { value: "21:30", label: "9:30 PM", disabled: false },
            { value: "22:00", label: "10:00 PM", disabled: false },
            { value: "22:30", label: "10:30 PM", disabled: false },
            { value: "23:00", label: "11:00 PM", disabled: false },
            { value: "23:30", label: "11:30 PM", disabled: false },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState("review", ["currentReview"]),
    ...mapGetters("review", ["currentReviewInviteRoles", "parentRoleTitle", "childRoleTitle"]),
    assignedToOptions(): any {
      return [
        { value: 1, label: (this as any).parentRoleTitle, disabled: false },
        { value: 2, label: (this as any).childRoleTitle, disabled: false },
        { value: 3, label: "Both", disabled: false },
      ];
    },
    showModal(): any {
      return this.showEditor;
    },
    currentReviewTimeRange() {
      let review = (this as any).currentReview;
      return {
        startDate: review.startDate,
        endDate: review.endDate,
        timezoneName: review.timezoneName,
      };
    },
    checkinDatesChanged() {
      let context = this as any;

      if (!context.objective.id || !context.objective.checkinDates || context.objective.checkinDates.length === 0) {
        return false;
      }

      let changed = false;
      context.objective.checkinDates.forEach((item) => {
        if (!this.currentObjective.checkinDates || this.currentObjective.checkinDates.filter((checkinDate) => checkinDate.date == item.date).length === 0) {
          changed = true;
          return;
        }
      });

      return changed;
    },
    objectiveDetailsCompleted(): any {
      return this.currentObjective.name !== null && this.currentObjective.name !== "" && this.currentObjective.priority !== null;
    },
    targetCompleted(): any {
      return this.currentObjective.targetType === 1
        ? this.currentObjective.trackingTarget !== "" && this.currentObjective.trackingTarget >= 0 && this.currentObjective.measurementUnit !== null && this.currentObjective.measurementUnit !== ""
        : this.currentObjective.inputOptions.length > 0;
    },
    getMetricTypeString(): any {
      if (this.currentObjective.measurementUnit === 2) {
        return "$";
      } else if (this.currentObjective.measurementUnit === 3) {
        return "%";
      } else {
        return "";
      }
    },
    durationString(): any {
      let review = (this as any).currentReview;
      if (review.startDate && review.endDate) {
        let end = moment(review.endDate);
        let start = moment(review.startDate);

        if (review.timezoneName) {
          start = start.tz(review.timezoneName);
          end = end.tz(review.timezoneName);
        }

        return `${start.format("MM/DD/YYYY")} - ${end.format("MM/DD/YYYY z")}`;
      } else {
        return "";
      }
    },
    friendlyTimezoneName() {
      let review = (this as any).currentReview;
      return review.timezoneName ? moment.tz(review.timezoneName).format(" (Z z)") : "";
    },
    rules() {
      return {
        targetType: [
          {
            type: "number",
            required: true,
            message: "Please select target type.",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "Please fill in the Name.",
            trigger: "change",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit Name to max 40 characters. Thanks!",
            trigger: "change",
          },
        ],
        trackingQuestion: [
          {
            type: "string",
            max: 60,
            message: "Please limit Check-in Question to max 60 characters. Thanks!",
            trigger: "blur",
          },
        ],
        priority: [
          {
            type: "number",
            required: true,
            message: "Please fill in the Priority.",
            trigger: "blur",
          },
          {
            type: "number",
            min: 1,
            max: (this as any).maxPriority,
            message: `Please enter 1 - ${(this as any).maxPriority}.`,
            trigger: "change",
          },
        ],
        trackingTarget: [
          {
            type: "number",
            required: true,
            message: "Please fill in the target.",
            trigger: "blur",
          },
        ],
        inputOptions: [
          {
            required: true,
            message: "Please define the scales",
          },
        ],
        measurementUnit: [
          {
            required: true,
            message: "Please fill in the Units.",
          },
          {
            type: "string",
            max: 20,
            message: "Please limit Units to max 20 characters. Thanks!",
            trigger: "blur",
          },
        ],
        checkinDates: [
          {
            required: true,
            message: "Please add Check-in days",
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("Please add Check-in days"));
              }
            },
            trigger: "change",
          },
        ],
        checkinTime: [
          {
            required: true,
            message: "Please select Check-in Time",
          },
        ],
      };
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.gotoPage("details");

        this.getMembers();

        this.maxPriority = this.objective.maxPriority;
        this.currentObjective.name = this.objective.name;
        this.currentObjective.description = this.objective.description;
        this.currentObjective.trackingQuestion = this.objective.trackingQuestion;
        this.currentObjective.priority = this.objective.priority;
        this.currentObjective.measurementUnit = this.objective.measurementUnit;
        this.currentObjective.targetType = this.objective.targetType;
        this.currentObjective.inputOptions = this.objective.inputOptions ? JSON.parse(this.objective.inputOptions) : [];
        this.currentObjective.trackingTarget = this.objective.trackingTarget;
        this.currentObjective.cronExpression = this.objective.cronExpression;
        this.currentObjective.checkinDates = this.objective.checkinDates ? JSON.parse(JSON.stringify(this.objective.checkinDates)) : [];
        this.currentObjective.checkinTime = this.objective.checkinTime;
        this.currentObjective.attachments = this.objective.attachments;

        this.disableAttachmentEdit = false;
      }
    },
    measurementUnit(newValue) {
      if (newValue === 2) {
        this.currentObjective.trackingTarget = 100;
      }
    },
  },
  methods: {
    handleRemoveInputOption(option) {
      for (var i = 0; i < this.currentObjective.inputOptions.length; i++) {
        if (this.currentObjective.inputOptions[i] === option) {
          this.currentObjective.inputOptions.splice(i, 1);
        }
      }
    },
    handleAddInputOption() {
      this.currentObjective.inputOptions.push({ label: "", value: null });
    },
    handleSelectDefinedDropdownList(item) {
      this.currentObjective.inputOptions = item.options.map((option) => {
        return Object.assign({}, option);
      });
    },
    handleSelectDefinedUnit(item) {
      this.currentObjective.measurementUnit = item.label;
    },
    getToValue(options, index) {
      if (index + 1 < options.length) {
        return options[index + 1].value + 1;
      } else {
        return 0;
      }
    },
    getMembers() {
      let review = (this as any).$store.state.review.currentReview;
      let members = review && review.members ? review.members : [];
      if (members === null) {
        members = [];
      }

      let allMembers = members.map((member, index) => {
        return {
          memberId: member.memberId,
          memberName: member.memberName,
          memberEmailAddress: member.memberEmailAddress,
          role: member.role,
        };
      });
    },
    handlerWizardStep(forward) {
      let steps = ["details", "target", "frequency"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.activePage) + (forward ? 1 : -1);
      this.gotoPage(steps[nextStepIndex]);
    },
    gotoPage(name) {
      this.activePage = name;
    },
    selectHandler(item) {
      this.activePage = item;
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.SetupForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let checkinDatesString = null;
          if (this.currentObjective.checkinDates && this.currentObjective.checkinDates.length > 0) {
            checkinDatesString = this.currentObjective.checkinDates
              .map((item) => {
                return `${item.date}`;
              })
              .reduce((previous, current) => {
                return `${previous};${current}`;
              });
          }
          let attachments = this.currentObjective.attachments ? this.currentObjective.attachments.filter((attachment) => attachment.status !== "new") : this.currentObjective.attachments;

          let objectiveDto = {
            id: this.objective.id,
            name: this.currentObjective.name,
            priority: this.currentObjective.priority,
            trackingQuestion: this.currentObjective.trackingQuestion,
            measurementUnit: this.currentObjective.measurementUnit,
            targetType: this.currentObjective.targetType,
            inputOptions: JSON.stringify(this.currentObjective.inputOptions),
            trackingTarget: this.currentObjective.targetType == 1 ? this.currentObjective.trackingTarget : 100,
            checkinDates: checkinDatesString,
            checkinTime: this.currentObjective.checkinTime,
            cronExpression: this.currentObjective.cronExpression,
            cronStartDate: (this as any).currentReview.startDate,
            cronEndDate: (this as any).currentReview.endDate,
            attachments: attachments ? JSON.stringify(attachments) : null,
            reviewId: this.objective.reviewId,
          };

          let context = this;
          context.$store
            .dispatch("review/upsertObjective", { data: objectiveDto })
            .then((response) => {
              context.$emit("cancel");
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          let fields = (form as any).fields.filter((field) => field.validateState === "error");
          if (fields != null && fields.length > 0) {
            let page = fields[0].$el.closest(".tab-content-wrap");
            if (page != null) {
              let pageName = page.getAttribute("name");
              this.gotoPage(pageName);
            }
          }
          target.disabled = false;
        }
      });
    },
    handleAddAttachment() {
      this.currentObjective.attachments.push({
        link: null,
        title: "",
        type: null,
        status: "new",
      });
    },
    handleAttachmentEditting() {
      this.disableAttachmentEdit = true;
    },
    handleAttachmentEdittingEnd() {
      this.disableAttachmentEdit = false;
    },
    handleAttachmentCancelNew() {
      if (this.currentObjective.attachments.length > 0 && this.currentObjective.attachments[this.currentObjective.attachments.length - 1]) {
        this.currentObjective.attachments.pop();
      }
    },
    handleAttachmentRemove(attachment) {
      this.currentObjective.attachments = this.currentObjective.attachments.filter((a) => {
        return a.link !== attachment.link;
      });
    },
    getPrettyDateString(date) {
      return moment(date).format("ddd M/D/YY");
    },
    datePickerChangeHandler(date) {
      this.datePickerValue = date;
    },
    openDatePicker() {
      this.showDatePicker = true;
      this.datePickerValue = "";
    },
    handleRecurrenceDaysGenerated(data) {
      this.currentObjective.cronExpression = data.cron;
      let days = data.days
        ? data.days.map((date) => {
            return { date: date.format("YYYY-MM-DD") };
          })
        : [];

      if (data.isAppend === true && this.currentObjective.checkinDates && this.currentObjective.checkinDates.length > 0) {
        days = days.filter((date, index) => {
          return this.currentObjective.checkinDates.filter((checkinDate) => checkinDate.date == date).length === 0;
        });

        days = _.union(this.currentObjective.checkinDates, days).sort((a, b) => {
          return a.date == b.date ? 0 : a.date > b.date ? 1 : -1;
        });
      }
      this.currentObjective.checkinDates = days;
    },
    addADayHandler() {
      if (this.datePickerValue != null && this.datePickerValue != "") {
        let dates = this.datePickerValue.split(",");
        dates = dates.filter((date, index) => {
          if (this.currentObjective.checkinDates) {
            return this.currentObjective.checkinDates.filter((checkinDate) => checkinDate.date == date).length === 0;
          } else {
            return true;
          }
        });

        this.currentObjective.checkinDates = _.union(
          this.currentObjective.checkinDates,
          dates.map((date) => {
            return { date: date };
          })
        ).sort((a, b) => {
          return a.date == b.date ? 0 : a.date > b.date ? 1 : -1;
        });

        this.validateCheckinDates();
      }

      this.showDatePicker = false;
    },
    removeCheckinDate(index) {
      this.currentObjective.checkinDates.splice(index, 1);
      this.validateCheckinDates();
    },
    validateCheckinDates() {
      let field = this.$refs.CheckInDatesField as any;
      field.validate("");
    },
    disabledDateForObjectives(date) {
      let review = (this as any).currentReview;
      let startDate = review.startDate ? new Date(review.startDate) : null;
      let endDate = review.endDate ? new Date(review.endDate) : null;
      let isDisabled = (startDate ? date < startDate : false) || (endDate ? date > endDate : false);

      return isDisabled;
    },
    formatNumber(num) {
      if (num && `${num}`.includes(".")) {
        return `${num}`.toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($1, $2) {
          return $2 + ",";
        });
      } else {
        return `${num}`.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
});
